import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { TopicsFilter } from '#src/app/pages/search/shared/components';
import { useLandingPage } from '#src/app/pages/search/shared/hooks';

export const TopicsSection: React.FC = () => {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	return (
		<div className={showLandingPage ? 'mt-8 md:mt-16' : 'hidden'}>
			<div className="container">
				<Text variant="heading" as="h2" size="small" className="mt-0">
					<Translate value="corgi.search.filters.topic.title" />
				</Text>
				<div className="mt-6 hidden md:block">
					<TopicsFilter chipSize="large" trackingContext="landing_topic" />
				</div>
				<div className="mt-6 block md:hidden">
					<TopicsFilter chipSize="small" trackingContext="landing_topic" />
				</div>
			</div>
		</div>
	);
};
